// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledContentWrapper = styled(Block)`
	margin-bottom: 0.75rem;
`;

// #####################################################
